<carousel [infinite]="carouselInfinite" [slideToScroll]="1" [slideToShow]="carouselSlidesToShow" [slideWidth]="260" [slideMaxWidth]="260" [counter]="false">
  <div class="carousel-slide" *ngFor="let course of courses">
    <app-course-view-grid [class]="course.title.length == 0 ? 'invisible' : ''"
      [course]="course"></app-course-view-grid>
  </div>
</carousel>